import { SET_GOOGLE_VOICES } from "../../Actions/Types";
import { GoogleGetVoicesAPI, voiceMakerGetVoicesAPI } from "../../Api/GoogleTTSAPI"

// service to get google TTS voices
const GoogleGetVoicesService = (dispatch: Function) => {
    // API to get google TTS voices
    Promise.all([
        GoogleGetVoicesAPI(),
        voiceMakerGetVoicesAPI()
    ]).then(([googleResponse, voiceMakerResponse]) => {
        const blockedLanguages = ["es-MX"];
        const googleVoices = googleResponse?.voices?.filter((voice:any) =>
            !voice.languageCodes?.some((code:any) => blockedLanguages.includes(code))
        );

        const convertedVoices = (voiceMakerResponse?.data?.voices_list ?? [])
        .filter((voice:any) => blockedLanguages.includes(voice.Language))
        .map((voice:any) => ({
            languageCodes: [voice.Language],
            name: voice.VoiceId,
            ssmlGender: voice.VoiceGender?.toUpperCase(),
            naturalSampleRateHertz: 24000,
            isFromOther: true,
        }));

        // merge voices (or process however you need)
        const combinedVoices = [...googleVoices, ...convertedVoices];

        dispatch({
            type: SET_GOOGLE_VOICES,
            payload: combinedVoices
        });

        }).catch(error => {
        console.error("Error fetching voices:", error);
    });
}

export { GoogleGetVoicesService };